const getOrigin = isEndUser => window.location.origin + (isEndUser ? '?connection=end-users' : '');

export default getOrigin;
